import { Box, Button, Container, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import NextLink from 'next/link'
import { pagesPath, staticPath } from '~/lib/$path'
import { SectionCardContainer } from '~/components/common/SectionCardContainer'
import AccountCircle from '@mui/icons-material/AccountCircle'
import { useViewerQuery } from '~/generated/graphql'

export const InformationForNewUsers = () => {
  const { data, loading } = useViewerQuery()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  if (loading || !data?.viewer.company?.showIntroduction) return null

  return (
    <SectionCardContainer
      icon={<AccountCircle sx={{ color: 'primary.main' }} />}
      title="はじめてのお客様へ"
      showAnimation
    >
      <Container maxWidth="md">
        <Stack gap={4} alignItems="center" maxWidth="100%" my={4}>
          <Stack gap={3} alignItems="center" sx={{ textAlign: 'center' }}>
            <Typography variant="h5" fontWeight="bold">
              toridori marketingにご登録いただき、ありがとうございます！
            </Typography>
            <Typography variant="h6" fontWeight="bold">
              PR依頼キャンペーンをインフルエンサーが見ているアプリ「toridori base」に掲載して、
              <br />
              投稿してくれるインフルエンサーを募集しましょう！
            </Typography>
          </Stack>
          <Stack direction="row" gap={2} flexWrap="wrap" justifyContent="space-around">
            <NextLink href={pagesPath.contract.$url()} legacyBehavior>
              <Button variant="contained" color="primary" sx={{ fontWeight: 'bold' }}>
                Step1: チケットの購入
              </Button>
            </NextLink>
            <NextLink href={pagesPath.campaign_create.$url()} legacyBehavior>
              <Button variant="contained" color="primary" sx={{ fontWeight: 'bold' }}>
                Step2: PR依頼キャンペーン作成
              </Button>
            </NextLink>
          </Stack>
          <Box
            maxWidth="100%"
            component="img"
            src={isMobile ? staticPath.info_for_new_user_1_sp_png : staticPath.info_for_new_user_1_png}
            alt="toridori marketing概要"
          />
          <Box
            maxWidth="100%"
            component="img"
            src={isMobile ? staticPath.info_for_new_user_2_sp_png : staticPath.info_for_new_user_2_png}
            alt="PR依頼から投稿完了までの流れ"
          />
        </Stack>
      </Container>
    </SectionCardContainer>
  )
}
